import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule as _StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { metaReducers as storageMetaReducers,  reducers } from './store.reducers';
import { NavigationActionTiming, RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { CustomSerializer } from './router/custom-serializer';



@NgModule({
  declarations: [],
  imports: [
    _StoreModule.forRoot(reducers , {

      metaReducers: storageMetaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },

    }),
    EffectsModule.forRoot([]),
    // Feed the `router` reducer with navigation actions. Without this the router slice is
    // registered (store.reducers) and a CustomSerializer is provided, but nothing ever dispatches
    // ROUTER_NAVIGATION/ROUTER_NAVIGATED — so `router.state` stays undefined forever and any
    // selector reading it (selectIsOnAppRoute → selectIsFullyAuthenticated, gating the per-login
    // date-format / release-notes loaders) is permanently false. The CustomSerializer only runs
    // because this module invokes it.
    //
    // navigationActionTiming: PostActivation is REQUIRED, not cosmetic. The default (PreActivation)
    // dispatches ROUTER_NAVIGATION on RoutesRecognized — BEFORE the route guards run — so `router.state.url`
    // becomes `/app/...` even for a navigation the enrollmentRequiredGuard is about to cancel. A forced-2FA
    // user cold-loading a bookmarked `/app` URL would then flip selectIsOnAppRoute→selectIsFullyAuthenticated
    // true for that pre-guard instant, firing the per-login loaders (DateFormatService / ReleaseNotesStateService
    // → GET /v2/userSettings) against the restricted enrollment token → 401 → interceptor refresh-retry →
    // endSession() bounces to /auth/login instead of the wizard. PostActivation defers ROUTER_NAVIGATION until
    // AFTER guards/resolvers, so a cancelled navigation never updates the URL slice (see @ngrx StoreRouterConfig).
    StoreRouterConnectingModule.forRoot({ navigationActionTiming: NavigationActionTiming.PostActivation }),
    CommonModule
  ],
  providers: [
    { provide: RouterStateSerializer, useClass: CustomSerializer }
  ]
})
export class StoreModule { }
